import HandleMatchPage from "@/pages/Manager/HandleMatch";
export default function HandleScoutingMatchPage(props) {
	return <HandleMatchPage {...props} scoutingContext />;
}
